import type { DomainAccount } from "@exopengithub/planning-api-shared";
import { createEntityAdapter } from "@reduxjs/toolkit";

export const accountsAdapter = createEntityAdapter<DomainAccount>();

export const accountsSelectors = accountsAdapter.getSelectors();
